import dates from "@/services/date";

let parseDate = function(value) {
  return dates.jsonDateToMonthYear(value);
};

export default {
  install: function (Vue) {
    Vue.filter('parseMonthVerbal', parseDate);
  }
}
